import React, { useState } from 'react';
import { ArrowRight, MapPin, Target, Wallet, Shield, GraduationCap, Gamepad2, Laptop, Building2, Truck, Leaf, Factory, ShoppingBag, Activity } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ConsultationPopup from '../components/ConsultationPopup';
import DealInterestPopup from '../components/DealInterestPopup';

const LiveDealsPage = () => {
  const [activeTab, setActiveTab] = useState('All Deals');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isInterestPopupOpen, setIsInterestPopupOpen] = useState(false);
  const [selectedDeal, setSelectedDeal] = useState(null);

  const tabs = ['All Deals', 'Active Deals', 'Closed Deals'];

  const deals = [
    {
      id: "SMVDM014", type: 'Active Deals', sector: 'HealthCare', subSector: 'HealthTech',
      title: 'HealthTech Platform', subTitle: 'Fund Raising',
      location: 'India', stage: 'Pre-Seed', fundingAsk: '$8M (~ INR 70 Cr)',
      icon: <Activity className="w-8 h-8 text-amber-500" />,
      image: "/images/stock/healthcare_sector.png"
    },
    {
      id: "SMVDM013", type: 'Active Deals', sector: 'DefenceTech', subSector: 'DefenceTech',
      title: 'Defence Solutions', subTitle: 'Fund Raising',
      location: 'India', stage: 'Pre-Seed', fundingAsk: '$1.5M (~ 10Cr)',
      icon: <Shield className="w-8 h-8 text-amber-500" />,
      image: "/images/stock/defense_sector.png"
    },
    {
      id: "SMVDM012", type: 'Active Deals', sector: 'EdTech', subSector: 'Education',
      title: 'Education Platform', subTitle: 'Fund Raising',
      location: 'India', stage: 'Seed', fundingAsk: '$0.5M (Bridge)',
      icon: <GraduationCap className="w-8 h-8 text-amber-500" />,
      image: "/images/stock/education_sector.png"
    },
    {
      id: "SMVDM011", type: 'Active Deals', sector: 'Gaming', subSector: 'Interactive Media',
      title: 'Gaming Studio', subTitle: 'Fund Raising',
      location: 'Middle East', stage: 'Seed', fundingAsk: '$5M',
      icon: <Gamepad2 className="w-8 h-8 text-amber-500" />,
      image: "/images/stock/gaming_sector.png"
    },
    {
      id: "SMVDM010", type: 'Active Deals', sector: 'Industry 4.0/IoT', subSector: 'Tech',
      title: 'IoT / Smart Industry', subTitle: 'Fund Raising',
      location: 'India', stage: 'Seed', fundingAsk: '$1M',
      icon: <Factory className="w-8 h-8 text-amber-500" />,
      image: "/images/stock/industry4_sector.png"
    },
    {
      id: "SMVDM009", type: 'Active Deals', sector: 'Data Center Services', subSector: 'Infrastructure',
      title: 'Data Center Provider', subTitle: 'M&A Advisory',
      location: 'India', stage: 'Seed', fundingAsk: 'Confidential',
      icon: <Building2 className="w-8 h-8 text-amber-500" />,
      image: "/images/stock/datacenter_sector.png"
    },
    {
      id: "SMVDM008", type: 'Closed Deals', sector: 'Fintech', subSector: 'Financial Services',
      title: 'Finvent', subTitle: 'Fund Raising (Closed)',
      location: 'MENA', stage: 'Seed', fundingAsk: 'Closed',
      icon: <Wallet className="w-8 h-8 text-amber-500" />,
      image: "/images/stock/fintech_sector.jpg"
    },
    {
      id: "SMVDM007", type: 'Closed Deals', sector: 'CleanTech', subSector: 'EV',
      title: 'iRasus', subTitle: 'Fund Raising (Closed)',
      location: 'India', stage: 'Seed', fundingAsk: 'Closed',
      icon: <Leaf className="w-8 h-8 text-amber-500" />,
      image: "/images/stock/automotive_sector.jpg"
    },
    {
      id: "SMVDM006", type: 'Closed Deals', sector: 'EdTech', subSector: 'Education',
      title: 'Omotec', subTitle: 'Fund Raising (Closed)',
      location: 'India', stage: 'Seed', fundingAsk: 'Closed',
      icon: <GraduationCap className="w-8 h-8 text-amber-500" />,
      image: "/images/stock/education_sector.png"
    },
    {
      id: "SMVDM005", type: 'Closed Deals', sector: 'Sustainability', subSector: 'Consumer',
      title: 'Amwoodo', subTitle: 'Fund Raising (Closed)',
      location: 'Kolkata', stage: 'Seed', fundingAsk: 'Closed',
      icon: <Leaf className="w-8 h-8 text-amber-500" />,
      image: "/images/stock/sustainability_sector.jpg"
    },
    {
      id: "SMVDM004", type: 'Closed Deals', sector: 'Fintech', subSector: 'Financial Services',
      title: 'Navadhan', subTitle: 'Fund Raising (Closed)',
      location: 'India', stage: 'Seed', fundingAsk: 'Closed',
      icon: <Wallet className="w-8 h-8 text-amber-500" />,
      image: "/images/stock/fintech_sector.jpg"
    },
    {
      id: "SMVDM003", type: 'Closed Deals', sector: 'Consumer', subSector: 'FMCG',
      title: 'Amaara Herbs', subTitle: 'Fund Raising (Closed)',
      location: 'India', stage: 'Seed', fundingAsk: 'Closed',
      icon: <ShoppingBag className="w-8 h-8 text-amber-500" />,
      image: "/images/stock/consumer_sector.jpg"
    },
    {
      id: "SMVDM002", type: 'Closed Deals', sector: 'Automotive', subSector: 'EV Components',
      title: 'TSUYO', subTitle: 'Fund Raising (Closed)',
      location: 'India', stage: 'Seed', fundingAsk: 'Closed',
      icon: <Truck className="w-8 h-8 text-amber-500" />,
      image: "/images/stock/automotive_sector.jpg"
    },
    {
      id: "SMVDM001", type: 'Closed Deals', sector: 'D2C', subSector: 'SkinCare',
      title: 'Auravedic', subTitle: 'Fund Raising (Closed)',
      location: 'India', stage: 'Seed', fundingAsk: 'Closed',
      icon: <ShoppingBag className="w-8 h-8 text-amber-500" />,
      image: "/images/stock/skincare_sector.jpg"
    }
  ];

  const filteredDeals = deals
    .filter(deal => activeTab === 'All Deals' || deal.type === activeTab)
    .sort((a, b) => {
      if (activeTab === 'All Deals') {
        if (a.type === 'Active Deals' && b.type === 'Closed Deals') return -1;
        if (a.type === 'Closed Deals' && b.type === 'Active Deals') return 1;
      }
      return 0;
    });

  const handleInterestClick = (deal) => {
    setSelectedDeal(deal);
    setIsInterestPopupOpen(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 flex flex-col">
      <Header />
      <ConsultationPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
      {/* Hero Section */}
      <section className="pt-32 pb-16 relative">
        <div className="container mx-auto px-4 z-10 relative">
          <div className="max-w-4xl mx-auto text-center">
            <Badge className="mb-6 bg-amber-500/10 text-amber-500 border-amber-500/20">Our Opportunities</Badge>
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Live Deals & Mandates
            </h1>
            <p className="text-xl text-slate-300 leading-relaxed max-w-3xl mx-auto">
              Explore our current and past fundraising and M&A mandates across diverse sectors.
            </p>
          </div>
        </div>
      </section>

      {/* Deals Section */}
      <section className="py-12 flex-1">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {tabs.map(tab => (
              <Button
                key={tab}
                variant={activeTab === tab ? 'default' : 'outline'}
                onClick={() => setActiveTab(tab)}
                className={`transition-all rounded-full px-8 ${activeTab === tab ? 'bg-amber-600 hover:bg-amber-700 text-white border-amber-600 shadow-lg shadow-amber-600/20' : 'border-slate-700 text-slate-300 hover:bg-slate-800'}`}
              >
                {tab}
              </Button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {filteredDeals.map((deal) => (
              <Card key={deal.id} className="bg-slate-900/60 border-slate-800 hover:border-amber-500/30 transition-all flex flex-col relative overflow-hidden group rounded-2xl shadow-xl">
                {/* Sector Image Header */}
                <div className="h-48 overflow-hidden relative">
                  <img 
                    src={deal.image || "/images/stock/corporate.jpg"} 
                    alt={deal.sector}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/20 to-transparent" />
                  <Badge className={`absolute top-4 right-4 ${deal.type === 'Active Deals' ? 'bg-green-500/10 text-green-400 border-green-500/20' : 'bg-amber-500/10 text-amber-500 border-amber-500/20'} font-bold px-3 py-1`}>
                    {deal.type === 'Active Deals' ? 'ACTIVE' : 'CLOSED'}
                  </Badge>
                  <div className="absolute bottom-4 left-6">
                    <div className="p-2.5 rounded-xl bg-slate-950/80 border border-slate-700/50 backdrop-blur-md text-amber-500 shadow-xl">
                      {deal.icon}
                    </div>
                  </div>
                </div>

                <CardContent className="pt-6 pb-8 flex-1 flex flex-col space-y-6 px-6">
                  <div>
                    <div className="text-amber-500 text-sm font-bold uppercase tracking-widest mb-1">{deal.id}</div>
                    <h3 className="text-2xl font-bold text-white mb-1 text-left line-clamp-1">{deal.title}</h3>
                    <div className="text-slate-400 font-medium text-left text-sm italic">{deal.subTitle}</div>
                  </div>

                  <div className="grid grid-cols-2 gap-y-5 text-sm text-left">
                    <div>
                      <div className="text-slate-500 text-[10px] uppercase font-bold tracking-[0.2em] mb-1.5">Sector</div>
                      <div className="text-slate-200 font-semibold">{deal.sector}</div>
                    </div>
                    <div>
                      <div className="text-slate-500 text-[10px] uppercase font-bold tracking-[0.2em] mb-1.5">Location</div>
                      <div className="text-slate-200 font-semibold flex items-center">
                        <MapPin className="w-3.5 h-3.5 text-amber-500 mr-1.5" />
                        {deal.location}
                      </div>
                    </div>
                    <div>
                      <div className="text-slate-500 text-[10px] uppercase font-bold tracking-[0.2em] mb-1.5">Stage</div>
                      <div className="text-slate-200 font-semibold">{deal.stage}</div>
                    </div>
                    <div>
                      <div className="text-slate-500 text-[10px] uppercase font-bold tracking-[0.2em] mb-1.5">Funding Ask</div>
                      <div className="text-amber-500 font-bold">{deal.fundingAsk}</div>
                    </div>
                  </div>

                  <div className="mt-auto pt-6 border-t border-slate-800/50">
                    {deal.type === 'Active Deals' ? (
                      <Button 
                        className="w-full bg-amber-600 hover:bg-amber-700 text-white font-bold h-14 rounded-xl shadow-lg shadow-amber-600/10 group/btn transition-all"
                        onClick={() => handleInterestClick(deal)}
                      >
                        I'm Interested in this deal
                        <ArrowRight className="ml-2 h-5 w-5 group-hover/btn:translate-x-1 transition-transform" />
                      </Button>
                    ) : (
                      <div className="h-14 flex items-center justify-center text-amber-500 font-bold italic tracking-wide bg-amber-500/10 rounded-xl border border-amber-500/20">
                        SUCCESSFULLY CLOSED
                      </div>
                    )}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-24 max-w-4xl mx-auto px-4">
          <div className="bg-slate-800/20 border border-slate-700/50 rounded-2xl p-8 text-center backdrop-blur-sm">
            <p className="text-slate-400 text-base leading-relaxed italic">
              "Every deal is unique & confidential. We share detailed information only after a formal introduction & NDA. If you're an investor looking for mandates in specific sectors, reach out to us."
            </p>
          </div>
        </div>
      </section>

      <Footer />
      <DealInterestPopup 
        isOpen={isInterestPopupOpen} 
        onClose={() => setIsInterestPopupOpen(false)} 
        deal={selectedDeal}
      />
    </div>
  );
};

export default LiveDealsPage;
